import React from "react";
import GuideSequence from "../components/GuideSequence";
import GuideModal from "../components/NativeGuideModal";
import { appstr } from "@coreapp/utils/appstr";
import { getImagePath } from "@coreapp/utils/getImagePath";
import type { GuideProps } from "../NativeGuideTypes";
import { Flex, Text } from "@theorgchartdev/storybook";

const IsolvedWelcomeGuide: React.FC<GuideProps> = props => (
  <GuideSequence {...props}>
    <GuideModal completeLabel={appstr("Let's go")} completeIcon="arrow-right-solid">
      <Flex
        className="oc-isolved-welcome-guide-logo"
        height="300px"
        alignItems="center"
        justifyContent="center"
      >
        <img
          src={getImagePath("/static/images/isolved-powered-by-orgchart.svg")}
          alt="isolved logo"
          width={245}
        />
      </Flex>
      <Flex alignItems="center" padding="16px" direction="column" gap="16px">
        <Text modifier="bold" size="small" style={{ textAlign: "center" }}>
          {appstr("Welcome to Your Charts, Powered by OrgChart!")}
        </Text>
        <Text
          size="small"
          style={{ textAlign: "center" }}
          dynamic={{
            template: appstr("isolvedFreeTrialTemplate"),
            formatConfig: {
              days: { type: "bold" },
              premiumOrgChartFeatures: { type: "bold" }
            },
            replaceDict: {
              days: appstr("21 days"),
              premiumOrgChartFeatures: appstr("premium org chart features")
            }
          }}
        >
          {appstr("isolvedFreeTrialMessage")}
        </Text>
        <Text size="small" style={{ textAlign: "center" }}>
          {appstr("Take the tour to get started and learn more!")}
        </Text>
      </Flex>
    </GuideModal>
  </GuideSequence>
);

export default IsolvedWelcomeGuide;
